// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';
import { getIsFBTShowEnabled } from '@tcp/core/src/reduxStore/selectors/session.selectors';
import getAddedToBagFormValues from '../../../../../reduxStore/selectors/form.selectors';
import { PRODUCT_ADD_TO_BAG } from '../../../../../constants/reducer.constants';
import { getDynamicLabelValues } from '../../../../../utils/labels/labelUtilty';
import { getProductIdWithQuantity } from '../../../../features/CnC/BagPage/container/BagPage.selectors';

const getQuickViewState = (state) => state.QuickView;

const getSortedProducts = (productInfo, cartItemsWithQty) => {
  if (!Array.isArray(productInfo)) return productInfo;
  const filteredProducts = [];
  productInfo.forEach((productobj) => {
    if (!productobj?.product?.colorFitsSizesMap?.length) return;
    if (cartItemsWithQty?.[productobj?.product?.generalProductId]) {
      filteredProducts.unshift(productobj);
    } else {
      filteredProducts.push(productobj);
    }
  });
  return filteredProducts;
};

export const getIsOutfitsOnBag = (state) => {
  return state.QuickView && state.QuickView.get('isOutfitsOnBag');
};

export const getProductInfo = createSelector(
  [getQuickViewState, getProductIdWithQuantity, getIsOutfitsOnBag],
  (quickViewState, cartItemsWithQty, isOutfitsOnBag) => {
    const productInfo = quickViewState && quickViewState.get('quickViewProducts');
    if (!isOutfitsOnBag) {
      return productInfo;
    }
    return getSortedProducts(productInfo, cartItemsWithQty);
  }
);

export const getQVProductData = createSelector(
  getQuickViewState,
  (quickViewState) => quickViewState && quickViewState.get('pdpProductData')
);

export const getProductInfoFromBag = (state) => {
  return state.QuickView && state.QuickView.get('quickViewProductFromBag');
};

export const getMultiPackProductInfo = (state) => {
  return state.QuickView && state.QuickView.get('newPartNumber');
};

export const getDisableMultiPackTab = (state) => {
  return state && state.QuickView && state.QuickView.get('disabledTab');
};

export const getInitialMultipackMappingQv = (state) => {
  return state && state.QuickView && state.QuickView.get('availableTCPMultipackProductMapping');
};

export const getInitialAvailableTCPmapNewStyleId = (state) => {
  return state && state.QuickView && state.QuickView.get('availableTCPmapNewStyleId');
};

export const getInitialColorConsolidationMultipackMapping = (state) => {
  return (
    state && state.QuickView && state.QuickView.get('availableColorConsolidationTCPmapNewStyleId')
  );
};

export const getInitialMultipackMappingQvQuickView = (state) => {
  return (
    state && state.QuickView && state.QuickView.get('availableTCPMultipackProductMappingQuickView')
  );
};
export const getSinglePageLoad = (state) => {
  return state && state.QuickView && state.QuickView.get('singlepageload');
};

export const getShowRatingView = (state) => {
  return state && state.QuickView && state.QuickView.get('showRatingView');
};

export const getInitialQuickViewLoad = (state) => {
  return state && state.QuickView && state.QuickView.get('initalQuickViewLoad');
};

export const getInitialTCPStyleQTYQv = (state) => {
  return state && state.QuickView && state.QuickView.get('initialSelectedQty');
};

export const getLoadingState = (state) => {
  return state.QuickView && state.QuickView.get('isLoading');
};

export const getLoadingError = (state) => {
  return state.QuickView && state.QuickView.get('isLoadingError');
};

export const getIsQVOpen = (state) => {
  return state.QuickView && state.QuickView.get('isModalOpen');
};

export const getFromPage = (state) => {
  return state.QuickView && state.QuickView.get('fromPage');
};

export const getFromPageBranch = (state) => {
  return state.QuickView && state.QuickView.get('fromPageBranch');
};

export const getFromBagPage = (state) => {
  return state.QuickView && state.QuickView.get('fromBagPage');
};

export const getFromAccessory = (state) => {
  return state.QuickView && state.QuickView.get('fromAccessory');
};

export const getPdpUrlFromBagPage = (state) => {
  return state.QuickView && state.QuickView.get('pdpUrl');
};

export const getIsFromBagProductSfl = (state) => {
  return state.QuickView && state.QuickView.get('isSflProduct');
};

export const getEditFavorite = (state) => {
  return state.QuickView && state.QuickView.get('isFavoriteEdit');
};

export const getIsFromStoreModal = (state) => {
  return state.QuickView.get('isFromStoreModal');
};

export const getFavoritePage = (state) => {
  return state.QuickView && state.QuickView.get('isFavoritePage');
};

export const getIsFromBirthdayModule = (state) => {
  return state.QuickView && state.QuickView.get('isFromBirthdayModule');
};

export const getQuickViewProductDetailPageTitle = (state) => {
  return state.QuickView && state.QuickView.get('pageTitle');
};

export const getQuickViewProductImage = (state) => {
  return state.QuickView && state.QuickView.get('productImage');
};

export const getGeneralProductId = (state) => {
  return state.QuickView && state.QuickView.getIn(['quickViewProducts', 'generalProductId']);
};

export const getModalState = (state) => {
  return state.QuickView && state.QuickView.get('isModalOpen');
};

export const getUniqueId = (state) => {
  return state.QuickView && state.QuickView.get('uniqueId');
};

export const getDimension66 = (state) => {
  return state.QuickView && state.QuickView.get('dimension66');
};
export const getDimension81 = (state) => {
  return state.QuickView.get('dimension81');
};

export const getEVar152 = (state) => {
  return state.QuickView && state.QuickView.get('eVar152');
};

export const getIsTopRated = (state) => {
  return state.QuickView.get('isTopRated');
};
export const getIsBestSeller = (state) => {
  return state.QuickView.get('isBestSeller');
};

export const getQuickViewFormValues = (state) => {
  const products = getProductInfo(state) || [];
  const isFBTEnabled = getIsFBTShowEnabled(state) || false;
  return products.map(({ product = {} } = {}, index) => {
    const { generalProductId } = product;
    const QVFormName =
      products?.length > 1
        ? `${PRODUCT_ADD_TO_BAG}-QV-${generalProductId}_${index}`
        : `${PRODUCT_ADD_TO_BAG}-QV-${generalProductId}`;
    const formName = `${PRODUCT_ADD_TO_BAG}-${generalProductId}`;
    const newFormName = isFBTEnabled ? QVFormName : formName;
    return getAddedToBagFormValues(state, newFormName);
  });
};

export const getQuickViewLabelsCopy = (quickViewLabelsNew) => {
  if (!quickViewLabelsNew)
    return {
      addToBag: '',
      editItem: '',
      editProduct: '',
      quickViewError: '',
      sorryErrorMsg: '',
      noProductSelected: '',
      viewProductDetails: '',
      availableInMoreColors: '',
      previousPrice: '',
      sizeGuide: '',
      shipIt: '',
      shipToHome: '',
      shipping: '',
      freeShipping: '',
      noMinimumRequired: '',
      pickItUp: '',
      pickUp: '',
      unavailable: '',
      norushpickUp: '',
      needItASAP: '',
      getItToday: '',
      selectedStore: '',
      viewFullProductDetails: '',
      deliveryMethod: '',
      selectStore: '',
      pickItUpInStore: '',
      extraPercentOff: '',
    };

  const {
    lbl_add_to_bag: addToBag,
    lbl_edit_item: editItem,
    lbl_edit_product: editProduct,
    lbl_quick_view_error: quickViewError,
    lbl_quick_view_sorry_message: sorryErrorMsg,
    plp_no_product_selected_error: noProductSelected,
    lbl_view_product_details: viewProductDetails,
    lbl_available_in_more_colors: availableInMoreColors,
    lbl_previous_price: previousPrice,
    lbl_size_guide: sizeGuide,
    lbl_ship_it: shipIt,
    lbl_ship_to_home: shipToHome,
    lbl_shipping: shipping,
    lbl_free_shipping: freeShipping,
    lbl_no_min_req: noMinimumRequired,
    lbl_pick_it_up: pickItUp,
    lbl_pick_up: pickUp,
    lbl_unavlbl: unavailable,
    lbl_no_rush_pick_up: norushpickUp,
    lbl_pick_up_txt_only: pickUpOnlyTxt,
    lbl_need_it_asap: needItASAP,
    lbl_get_it_today: getItToday,
    lbl_Product_pickup_SELECTED_STORE: selectedStore,
    lbl_view_full_product_details: viewFullProductDetails,
    lbl_delivery_method: deliveryMethod,
    lbl_select_a_store: selectStore,
    lbl_pick_it_up_in_store: pickItUpInStore,
    lbl_extra_percent: extraPercentOff,
  } = quickViewLabelsNew;

  return {
    addToBag,
    editItem,
    editProduct,
    quickViewError,
    sorryErrorMsg,
    noProductSelected,
    viewProductDetails,
    availableInMoreColors,
    previousPrice,
    sizeGuide,
    shipIt,
    shipToHome,
    shipping,
    freeShipping,
    noMinimumRequired,
    pickItUp,
    pickUp,
    unavailable,
    norushpickUp,
    needItASAP,
    getItToday,
    selectedStore,
    viewFullProductDetails,
    deliveryMethod,
    selectStore,
    pickItUpInStore,
    extraPercentOff,
    pickUpOnlyTxt,
  };
};

export const getQuickViewRichTextContentId = () => {
  const qvLabels = getDynamicLabelValues('Browse.QuickView');
  let quickViewRichTextContentId;
  if (qvLabels && Array.isArray(qvLabels?.referred)) {
    qvLabels.referred.forEach((label) => {
      if (label.name === 'Quick View Promo') quickViewRichTextContentId = label.contentId;
    });
  }
  return quickViewRichTextContentId;
};

export const getQuickViewRichTextSelector = (state) => {
  return state.QuickView && state.QuickView.get('quickViewPromo');
};

export const getDeliveryMethodIndex = (state) => {
  return state && state.ProductDetail && state.ProductDetail.deliveryMethodIndex;
};

export const getSBPNavigationDetails = (state) => {
  return (state.QuickView && state.QuickView.get('sbpNavigation')) || {};
};

export const getIsFromSBPPLP = (state) => {
  return (state.QuickView && state.QuickView.get('isSBP')) || false;
};
export const getDeliveryMethodIndexFromCart = (state) => {
  return state && state.ProductDetail && state.ProductDetail.deliveryMethodIndexCart;
};
export const getIsKeepMinibagCloseQV = (state) => {
  return state.QuickView && state.QuickView.get('keepMinibagClose');
};

export const getBrandName = (state) => {
  return (state.QuickView && state.QuickView.get('brandName')?.brandName) || '';
};

export const getTotalPrices = (state) => {
  return (state.QuickView && state.QuickView.get('totalPrices')?.totalPrices) || '';
};

export const getPreviousScreen = (state) => {
  return state.QuickView && state.QuickView.get('previousScreen');
};

export const getPreviousScreenID = (state) => {
  return state.QuickView && state.QuickView.get('previousScreenID');
};

const getCategoryListing = (state) => state?.CategoryListingPage || {};
const getAppliedFilters = createSelector(
  getCategoryListing,
  (categoryListing) => categoryListing?.appliedFilters || {}
);

const getHorizontalCategory = (state) => state?.HorizontalCategory || {};

const getHplpAppliedFilters = createSelector(
  getHorizontalCategory,
  (horizontalCategory) => horizontalCategory?.appliedFilters || {}
);

export const getHplpSizeFilterDetails = createSelector(getHplpAppliedFilters, (appliedFilters) => {
  const { v_tcpsize_uFilter: sizeNameArr = [] } = appliedFilters;
  return sizeNameArr;
});

export const getHplpClothingSizefilterDetails = createSelector(
  getHplpAppliedFilters,
  (appliedFilters) => {
    const { v_clothingsize_uFilter: clothingSizeNameArr = [] } = appliedFilters;
    return clothingSizeNameArr;
  }
);

export const getHplpShoesSizefilterDetails = createSelector(
  getHplpAppliedFilters,
  (appliedFilters) => {
    const { v_shoessize_uFilter: shoesSizeNameArr = [] } = appliedFilters;
    return shoesSizeNameArr;
  }
);

export const getHplpAccessoriesSizeFilterDetails = createSelector(
  getHplpAppliedFilters,
  (appliedFilters) => {
    const { v_accessoriessize_uFilter: accessoriesSizeNameArr = [] } = appliedFilters;
    return accessoriesSizeNameArr;
  }
);

export const getsizefilterDetails = createSelector(getAppliedFilters, (appliedFilters) => {
  const { v_tcpsize_uFilter: sizeNameArr = [] } = appliedFilters;
  return sizeNameArr;
});

export const getClothingSizefilterDetails = createSelector(getAppliedFilters, (appliedFilters) => {
  const { v_clothingsize_uFilter: clothingSizeNameArr = [] } = appliedFilters;
  return clothingSizeNameArr;
});

export const getShoesSizefilterDetails = createSelector(getAppliedFilters, (appliedFilters) => {
  const { v_shoessize_uFilter: shoesSizeNameArr = [] } = appliedFilters;
  return shoesSizeNameArr;
});

export const getAccessoriesSizefilterDetails = createSelector(
  getAppliedFilters,
  (appliedFilters) => {
    const { v_accessoriessize_uFilter: accessoriesSizeNameArr = [] } = appliedFilters;
    return accessoriesSizeNameArr;
  }
);

export const getHplpFitfilterDetails = (state) => {
  const { appliedFilters = {} } = state.HorizontalCategory || {};
  const { v_tcpfit_unbxd_uFilter: fitFilterArr = [] } = appliedFilters;
  return fitFilterArr;
};

export const getFitfilterDetails = (state) => {
  const { appliedFilters = {} } = state.CategoryListingPage || {};
  const { v_tcpfit_unbxd_uFilter: fitFilterArr = [] } = appliedFilters;
  return fitFilterArr;
};

export const getPlpProductData = (state) => {
  return state && state.QuickView && state.QuickView.get('plpProductData');
};

export const getSlpProductData = (state) => {
  return state && state.QuickView && state.QuickView.get('slpProductData');
};

export const getPlpItemData = (state) => {
  return state && state.QuickView && state.QuickView.get('plpItemData');
};

const searchListingDetail = (state) => state?.SearchListingPage;

export const getSearchListingDetail = createSelector(
  searchListingDetail,
  (searchListing) => searchListing
);
